<template>
  <div>
    <div style="align-content: center; margin: 30px auto;">
      <ApplicationCard
        name="Portail Outils"
        color="#566f98"
        icon-name="el-icon-menu"
        @click="openApplicationOutils"
        :disabled="!shopToken"
        :is-loading="loadingToken"
      />
      <ApplicationCard
        v-for="app in apps" :key="app.id"
        :is-loading="loading[app.id]"
        :name="app.name"
        :icon-name="app.icon"
        :disabled="app.disabled || loading[app.id] || !shopToken"
        :color="app.color"
        @click="onAppOpened(app)"
      />
    </div>
  </div>
</template>
<script>
import { ShopSessionManager } from '@holdingblachere/js-sdk';
import services from 'services';
import ApplicationCard from '@/components/ApplicationCard.vue';

export default {
  components: {
    ApplicationCard,
  },
  props: {
    shopId: { type: String, required: true },
    shopType: { type: String, required: true },
    shopToken: { type: String },
    loadingToken: { type: Boolean },
  },
  data() {
    return {
      loading: {
        amc: false,
        inv: false,
        market: false,
        recep: false,
        embauche: false,
        planning: false,
      },
    };
  },
  methods: {
    async openApplicationOutils() {
      window.open(`${process.env.VUE_APP_OUTILS_APP_BASE_URL}?token=${this.shopToken}`, '_blank').focus();
    },
    async openInternalAppWithSimpleShopToken(appUrl, shopToken) {
      if (!shopToken) {
        this.$message.error('Aucun jeton magasin trouvé.');
      }
      window.open(`${appUrl}?token=${shopToken}`, '_blank').focus();
    },
    monCompteBackUrl(shopType) {
      if (this.isPortugalShop) {
        return process.env.VUE_APP_MON_COMPTE_CDM_PRT_BACKEND_URL;
      }
      return shopType === services.shopService.shopTypes.MB
        ? process.env.VUE_APP_MON_COMPTE_MB_BACKEND_URL
        : process.env.VUE_APP_MON_COMPTE_FL_BACKEND_URL;
    },
    monCompteFrontUrl(shopType) {
      if (this.isPortugalShop) {
        return process.env.VUE_APP_MON_COMPTE_CDM_PRT_APP_URL;
      }
      return shopType === services.shopService.shopTypes.MB
        ? process.env.VUE_APP_MON_COMPTE_MB_APP_URL
        : process.env.VUE_APP_MON_COMPTE_FL_APP_URL;
    },
    marketBackUrl(shopType) {
      return shopType === services.shopService.shopTypes.MB
        ? process.env.VUE_APP_MARKETPLACE_BACKEND_MB_URL
        : process.env.VUE_APP_MARKETPLACE_BACKEND_FL_URL;
    },
    marketFrontUrl(shopType) {
      return shopType === services.shopService.shopTypes.MB
        ? process.env.VUE_APP_MARKETPLACE_MB_APP_URL
        : process.env.VUE_APP_MARKETPLACE_FL_APP_URL;
    },
    inventaireBackUrl(shopType) {
      return shopType === services.shopService.shopTypes.MB
        ? process.env.VUE_APP_INVENTAIRE_BACKEND_MB_URL
        : process.env.VUE_APP_INVENTAIRE_BACKEND_FL_URL;
    },
    inventaireFrontUrl(shopType) {
      return shopType === services.shopService.shopTypes.MB
        ? process.env.VUE_APP_INVENTAIRE_MB_APP_URL
        : process.env.VUE_APP_INVENTAIRE_FL_APP_URL;
    },
    async onAppOpened(app) {
      this.loading[app.id] = true;
      try {
        if (app.isInternalApp) {
          await this.openInternalAppWithSimpleShopToken(app.frontUrl, this.shopToken);
        } else {
          const currentUserToken = this.$store.getters['auth/currentUserToken'];
          if (!currentUserToken) {
            this.$message.error('Utilisateur non connecté');
            await this.$router.push({ name: 'Logout' });
          }
          const sessionManager = new ShopSessionManager({ url: app.backUrl });
          console.log('CREATE SHOP SESSION', this.shopId);
          const session = await sessionManager.createShopSessionWithToken(
            this.shopId,
            currentUserToken,
          );

          if (!session) {
            this.$message.error('Impossible de générer la session');
          }

          window.open(
            `${app.frontUrl}/connexion-sid?sid=${session.sessionId}`,
            '_blank',
          ).focus();
        }
      } catch {
        this.$message.error({
          message: 'Impossible de générer la session, êtes vous sûr(e) que le magasin existe pour l\'application demandée ?',
          type: 'error',
          duration: -1,
          showClose: true,
        });
      } finally {
        this.loading[app.id] = false;
      }
    },
  },
  computed: {
    isPortugalShop() {
      return process.env.VUE_APP_ORGANIZATION === 'CDM_PRT';
    },
    apps() {
      return [
        {
          id: 'amc',
          name: 'Mon Compte',
          color: '#fd7e12',
          icon: 'el-icon-user',
          show: true,
          backUrl: this.monCompteBackUrl(this.shopType),
          frontUrl: this.monCompteFrontUrl(this.shopType),
          disabled: false,
        },
        {
          id: 'market',
          name: 'Marketplace',
          color: '#ba13f0',
          icon: 'el-icon-s-shop',
          show: !this.isPortugalShop,
          backUrl: this.marketBackUrl(this.shopType),
          frontUrl: this.marketFrontUrl(this.shopType),
          disabled: false,
        },
        {
          id: 'inv',
          name: 'Inventaire',
          color: '#23cdaa',
          icon: 'el-icon-notebook-2',
          show: !this.isPortugalShop && this.shopType === 'MB',
          backUrl: this.inventaireBackUrl(this.shopType),
          frontUrl: this.inventaireFrontUrl(this.shopType),
          disabled: false,
        },
        {
          id: 'planning',
          name: 'Planning',
          color: '#16a9bf',
          icon: 'el-icon-date',
          show: true,
          isInternalApp: true,
          frontUrl: 'https://planning-outils.marieblachere.fr',
          disabled: false,
        },
        {
          id: 'embauche',
          name: 'Demande Embauche',
          color: '#1192ef',
          icon: 'el-icon-edit',
          show: true,
          isInternalApp: true,
          frontUrl: 'https://authorize-outils.marieblachere.fr',
          disabled: false,
        },
        // {id: 'recep', name: 'Réception (bientôt)', disabled: true},
      ].filter((app) => app.show);
    },
  },
};
</script>
<style lang="stylus" scoped>
</style>
